'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = List;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./list.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH List Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function List(props) {
    var _cx;

    var _props$style = props.style,
        style = _props$style === undefined ? '' : _props$style,
        _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$spacing = props.spacing,
        spacing = _props$spacing === undefined ? '' : _props$spacing,
        _props$hasIcons = props.hasIcons,
        hasIcons = _props$hasIcons === undefined ? false : _props$hasIcons,
        _props$isInline = props.isInline,
        isInline = _props$isInline === undefined ? false : _props$isInline,
        children = props.children,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id;

    var classNames = (0, _classnames2.default)((_cx = {
        'sb-list': !isInline,
        'sb-list-inline': isInline,
        'sb-list--icon': hasIcons
    }, (0, _defineProperty3.default)(_cx, 'sb-list--' + style, style), (0, _defineProperty3.default)(_cx, 'sb-list-inline--' + spacing, spacing), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('ul', {
        className: classNames,
        id: id
    }, void 0, children);
}
// css
//# sourceMappingURL=List.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/list/List.js
// module id = 576
// module chunks = 0